import React from 'react'
import PropTypes from 'prop-types'

const FilePersionIcon = (props) => {
  const { color = '#183560', classes = 'w-20' } = props
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 6.125H12L10 4H4C2.9 4 2.01 4.95625 2.01 6.125L2 18.875C2 20.0438 2.9 21 4 21H20C21.1 21 22 20.0438 22 18.875V8.25C22 7.08125 21.1 6.125 20 6.125ZM20 18.875H4V6.125H9.17L11.17 8.25H20V18.875ZM15 13.5625C16.1 13.5625 17 12.6062 17 11.4375C17 10.2688 16.1 9.3125 15 9.3125C13.9 9.3125 13 10.2688 13 11.4375C13 12.6062 13.9 13.5625 15 13.5625ZM11 17.8125H19V16.75C19 15.3369 16.33 14.625 15 14.625C13.67 14.625 11 15.3369 11 16.75V17.8125Z"
        fill={color}
      />
    </svg>
  )
}

FilePersionIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(FilePersionIcon)
